import { CalendarEventDisplayType } from '../../enums'
import { FoodBookingModel, ServiceBookingModel } from '../booking'
import { ViewFoodEvent } from '../food'
import { ViewEmployeeAbsence } from '../service'

export interface CalendarEvent {
  id: string
  start: Date | string
  end?: Date | string
  allDay: boolean
  title: string
  durationEditable: boolean
  resourceIds?: string[]
  backgroundColor: string
  borderColor: string
  textColor: string
  editable?: boolean
  display?: CalendarEventDisplayType
  data?: FoodBookingModel | ServiceBookingModel | ViewEmployeeAbsence | ViewFoodEvent
  type: 'booking' | 'absence' | 'foodEvent' | 'buffer' | 'closedSociety' | (string & {})
}

export const isBooking = (data: CalendarEvent): data is CalendarEvent => {
  return !!data.data && 'type' in data && data.type === 'booking'
}

export const isEvent = (data: CalendarEvent): data is CalendarEvent => {
  return !!data.data && 'type' in data && data.type === 'foodEvent'
}

export const isAbsence = (data: CalendarEvent): data is CalendarEvent => {
  return !!data.data && 'type' in data && data.type === 'absence'
}

export const getEntityType = (data: CalendarEvent): 'booking' | 'foodEvent' | 'absence' => {
  if (isEvent(data)) return 'foodEvent'
  if (isAbsence(data)) return 'absence'
  return 'booking'
}
